import { Utils } from "@/plugins/utils";
import router from '@/router';
import moment from "moment";

export default {
    namespaced: true,
    state: {
        lstCb0: [],
        cb0: null,
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        search: "",
        hasNext: false,
        lastUpdatedRegister: null,
        pending: false,
        campaignStatus: [0,1]
    },
    getters: {
        getUpdate(state) {
            return state.update
        },
        getCb0(state) {
            let cb0 = { ...state.cb0 }
            cb0.cb0inicio = cb0.cb0inicio ? Utils.ParseToDate(cb0.cb0inicio) : new Date(1900, 1, 1)
            cb0.cb0fim = cb0.cb0fim ? Utils.ParseToDate(cb0.cb0fim) : new Date(1900, 1, 1)
            cb0.cb0inicio.setUTCHours(0, 0, 0, 0);
            cb0.cb0fim.setUTCHours(23, 59, 59, 999);
            return cb0
        },
        getCb0camp(state) {
            return state.cb0.cb0camp
        },
        getSearch(state) {
            return state.search
        },
        getItemsPerPage(state) {
            return state.itemsPerPage
        }
    },
    mutations: {
        set(state, cb0) {
            state.cb0 = cb0
            state.cb0.cb0fim = new Date(cb0.cb0fim).toLocaleString(navigator.language, {
				year: "numeric",
				month: "2-digit",
				day: "2-digit",
			})
            state.cb0.cb0inicio = new Date(cb0.cb0inicio).toLocaleString(navigator.language, {
				year: "numeric",
				month: "2-digit",
				day: "2-digit",
			})
            if (cb0)
                state.update = true
        },
        initForm(state) {
            state.insert = false
            state.update = false
            state.cb0 = null
        },
        setParamsDataTable(state, payload) {
            state.lstCb0 = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setCb0(state, cb0) {
            state.cb0 = cb0
        },
        setLstCb0(state, lstCb0) {
            state.lstCb0 = lstCb0
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setSearch(state, search) {
            state.search = search
        },
        setLastUpdatedRegister(state, lastUpdatedRegister) {
            state.lastUpdatedRegister = lastUpdatedRegister
        },
    },
    actions: {
        initForm({ commit }) {
            commit("initForm")
        },
        async find({ commit, dispatch }, cb0camp) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Financial/CashbackCampaign/Find/${cb0camp}`)
                .then(response => {
                    let cb0 = Utils.ValidateAxiosResponse(response.data);
                    commit("set", cb0)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
            commit("setLoading", false)
        },
        async save({ getters, dispatch }) {
            if (getters.getUpdate) {
                return await dispatch("update")
            }
            return await dispatch("insert")
        },
        async insert({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.post("/Financial/CashbackCampaign/Insert", getters.getCb0)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    commit("setCb0", null)
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload;
        },
        async update({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.put("/Financial/CashbackCampaign/Update", getters.getCb0)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },
        async delete({ getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
            await this._vm.$axios.delete(`/Financial/CashbackCampaign/Delete/${getters.getCb0camp}`)
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data);
                    router.push("/oryxpdv/campanhas-cashbacks")
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
        },
        async findList({ commit, getters, dispatch }) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Financial/CashbackCampaign/FindList`, getters.getCb0)
                .then(response => {
                    let lstCb0 = Utils.ValidateAxiosResponse(response.data);
                    commit("setLstCb0", lstCb0)
                    commit("setHasNext", lstCb0.length > getters.getItemsPerPage)
                }).catch(error => {
                    commit("setLstCb0", [])
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                })
            commit("setLoading", false)
        },
        async search({ commit, getters, dispatch, state }, { limit = 20, page = 1 }) {
            commit("setLoading", true)
            commit("initForm")

            if(state.campaignStatus.length == 0)
				state.campaignStatus = [0,1]

			let campaignStatus = ""
			for (const status of state.campaignStatus) {
				campaignStatus += "&campaignStatus=" + status
            }
            let payload = await this._vm.$axios.get(`/Financial/CashbackCampaign/Search?search=${getters.getSearch}&limit=${limit}&page=${page}${campaignStatus}`)
                .then(response => {
                    let payload = Utils.ValidateAxiosResponse(response.data);
                    commit("setParamsDataTable", payload)
                    return true
                })
                .catch((error) => {
                    commit("setLstCb0", [])
                    commit("setSearch", "")
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            commit("setLoading", false)
            return payload
        }
    }
}